export default __webpack_public_path__ + "static/media/545.7553a63e.png";